import { render, staticRenderFns } from "./VehiclesCreate.vue?vue&type=template&id=a06d1870&scoped=true"
import script from "./VehiclesCreate.vue?vue&type=script&lang=js"
export * from "./VehiclesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06d1870",
  null
  
)

export default component.exports